module.exports = __webpack_public_path__ + "media/images/riders/small/ANNIE_LAST-f25b7ade4515d7918d7a37371c4aa480.png";